module.exports = __webpack_public_path__ + "static/media/picture9@2x.1310a5c7.png";